export default "__VITE_ASSET__9e62gsuf__"